var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1286 14.3036C15.375 13.9964 15.325 13.5464 15.0179 13.3L15.1286 14.3036ZM15.1286 14.3036C15.0619 14.3873 14.9771 14.4549 14.8807 14.5013M15.1286 14.3036L14.8807 14.5013M14.8807 14.5013C14.7842 14.5477 14.6785 14.5716 14.5714 14.5714L14.8807 14.5013ZM10.5358 5.27843C10.5397 5.02694 10.7476 4.82142 11 4.82142C11.2548 4.82142 11.4643 5.03092 11.4643 5.28572V10.6572V10.7773L11.5581 10.8524L14.8614 13.495C15.0612 13.6553 15.0934 13.948 14.9336 14.1471L14.933 14.1478C14.8898 14.2021 14.8349 14.2459 14.7723 14.276C14.7098 14.306 14.6413 14.3216 14.5719 14.3214H14.5714C14.468 14.3214 14.3673 14.2889 14.2825 14.2201L14.2812 14.219L10.7108 11.3628C10.7106 11.3626 10.7105 11.3625 10.7103 11.3624C10.6 11.273 10.5358 11.1404 10.5358 11V5.28572V5.27843ZM11 21.25C16.6595 21.25 21.25 16.6595 21.25 11C21.25 5.34049 16.6595 0.75 11 0.75C5.34049 0.75 0.75 5.34049 0.75 11C0.75 16.6595 5.34049 21.25 11 21.25Z",
    fill: "url(#paint0_radial_9_19)",
    stroke: "#FF9000",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9_19",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11 11) scale(7.5 9.5433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05C1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.9545724ec9ee33c74470f557bd3565c7.svg";
export { ForwardRef as ReactComponent };